// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './components/Home';
import Products from './components/Products';
import Workshops from './components/Workshops';
import Platform from './components/Platform';
import Partners from './components/Partners';
import Team from './components/Team';
import Contact from './components/Contact';
import NewHome from './components/NewHome';
import Robotics from './Pages/Robotics';
import './App.css';

function App() {
  return (
    <Router>
      <div className="app">
        {/* <Navbar /> */}
        <Routes>
          <Route path="/" element={<NewHome />} />
          <Route path="/products" element={<Products />} />
          <Route path="/workshops" element={<Workshops />} />
          <Route path="/platform" element={<Platform />} />
          <Route path="/partners" element={<Partners />} />
          <Route path="/team" element={<Team />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/robotics" element={<Robotics />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;


